export function canAgeUp({age, food, gold, civ, hasDiscount}) {

    let discount = 1;

    if (hasDiscount && civ === 'Abbasid') {
        discount = 0.8;
    } else if (hasDiscount && civ === "Zhu Xi's Legacy") {
        discount = 0.85;
    } else if ((civ === 'Holy Roman Empire' || civ === "Order of the Dragon") && age === 3) {
        discount = 0.9;
    }

    if (age === 1) {
        return food >= 400 * discount && gold >= 200 * discount;
    } else if (age === 2) {
        return food >= 1200 * discount && gold >= 600 * discount;
    } else if (age === 3) {
        return food >= 2400 * discount && gold >= 1200 * discount;
    }
    return false;
}